import gridhelper from "../views/gridhelper";
import {renderDate, renderLicenceType} from "./renderer";

function getStaticColumns() {
    return [
        {
            field: "licenceType",
            header: "Type",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: renderLicenceType
        },
        {
            field: "licenceTerritory",
            header: "Territory",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "typeOfRight",
            header: "Type of right",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "dateFrom",
            header: "From",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: renderDate
        },
        {
            field: "dateTo",
            header: "Until",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: renderDate
        },
        // {
        //     field: "licenceUnlimited",
        //     header: "Unlimited",
        //     headerStyle: "width: 150px",
        //     isDropDownFilter: true,
        //     isTextFilter: false,
        //     getter: gridhelper.renderDefault
        // },
        {
            field: "exclusive",
            header: "Exclusive",
            headerStyle: "width: 100px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderBoolean
        },
        {
            field: "tba",
            header: "tba",
            headerStyle: "width: 60px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderBoolean
        },
        {
            field: "blockCategory",
            header: "Blocking Category",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "languageVersionAllowed",
            header: "Languages",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "languageVersionExcluded",
            header: "Languages X",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "contractPartner",
            header: "Contract Partner",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "contractNoExternal",
            header: "Contract No.",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "contractStatus",
            header: "Contract state",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
        {
            field: "client",
            header: "Client",
            headerStyle: "width: 150px",
            isDropDownFilter: true,
            isTextFilter: false,
            getter: gridhelper.renderDefault
        },
    ]
}

export {getStaticColumns}
